import React from 'react';

import { Icon } from '../icons';

export const GoogleIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M31.483871,16.3741935 C31.483871,25.5032258 25.2322581,32 16,32 C7.1483871,32 0,24.8516129 0,16 C0,7.1483871 7.1483871,0 16,0 C20.3096774,0 23.9354839,1.58064516 26.7290323,4.18709677 L22.3741935,8.37419355 C16.6774194,2.87741935 6.08387097,7.00645161 6.08387097,16 C6.08387097,21.5806452 10.5419355,26.1032258 16,26.1032258 C22.3354839,26.1032258 24.7096774,21.5612903 25.083871,19.2064516 L16,19.2064516 L16,13.7032258 L31.2322581,13.7032258 C31.3806452,14.5225806 31.483871,15.3096774 31.483871,16.3741935 Z" />
    </svg>
  );
};
